import React from 'react';

import Button from 'components/shared/Button/Button';
import Dot from 'components/shared/Dot/Dot';
import Icon from 'components/shared/Icon/Icon';
import Popover from 'components/shared/Popovers/Popover/Popover';
import Progress from 'components/shared/Progress/Progress';

const AccordionTrigger = ({
  open,
  ButtonComponent,
  stepTitle,
  isStepCompleted,
  isStepConfirmed,
  completedSubsteps,
  totalSubsteps,
  completedSubstepsPercentage,
  onConfirmClick,
  onUnconfirmClick
}) => {
  if (ButtonComponent) {
    return React.isValidElement(ButtonComponent) ? (
      React.cloneElement(ButtonComponent, { open })
    ) : (
      <ButtonComponent open={open} />
    );
  }

  return (
    <>
      <div className="flex w-fit items-center gap-2 py-0.5">
        <Icon
          size={20}
          color="neutral"
          shade={700}
          icon={!open ? 'chevron-right-linear' : 'chevron-down-linear'}
        />
        {isStepConfirmed ? (
          <Icon size={28} icon="tick-circle-filled" color="success" />
        ) : isStepCompleted ? (
          <Icon size={28} icon="tick-circle-linear" color="success" />
        ) : (
          <Progress className="bg-neutral-50" percentage={completedSubstepsPercentage} />
        )}
        <p className="text-sm font-500">{stepTitle}</p>
        {isStepConfirmed && (
          <div className="ml-2 flex items-center gap-1 rounded-2xl border border-solid border-black border-opacity-15 bg-success-100 px-2 py-0.5 text-xs font-500">
            <Dot color="success" size="sm" />
            Confirmed
          </div>
        )}
      </div>
      <div className="flex w-fit items-center gap-2">
        <p className="text-xs text-neutral-800">
          Completed <b>{completedSubsteps ?? 0}</b> out of <b>{totalSubsteps ?? 0}</b>
        </p>
        <p className="mx-1">/</p>
        {isStepConfirmed ? (
          <Popover
            isFixed
            isBorder
            position="left"
            options={[
              {
                label: 'Unconfirm',
                icon: 'minus-circle-mono',
                onClick: onUnconfirmClick
              }
            ]}
            buttonClassName="border border-solid border-neutral-200 p-1 !min-w-6 !h-6 bg-white"
          />
        ) : (
          <Button
            size="xs"
            color="neutral"
            style="outlined"
            text="Confirm"
            shade={700}
            onClick={onConfirmClick}
            icon="checkbox-circle-mono"
          />
        )}
      </div>
    </>
  );
};

export default AccordionTrigger;
